import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { AppIcons } from '../../../shared/app.icons';
import { AppSettings } from '../../../shared/app.settings';
import { MITableComponent } from '../../../shared/components/mi-table/mi-table.component';
import { Country } from '../../../shared/models/country';
import { Language } from '../../../shared/models/language';
import { CommonBindingDataService } from '../../../shared/services/common-binding-data.service';
import { EntityService } from '../../../shared/services/entity.service';
import { LoaderService } from '../../../shared/components/loader/loader.service';
import { PermissionAccessService } from '../../../shared/services/permission-access.service';
import { RestApiService } from '../../../shared/services/rest-api.service';
import { ConfigService } from '../../../shared/services/config.service';
import { TranslateModule } from '@ngx-translate/core';
import { AccessProviderDirective } from '../../../shared/directives/access-provider.directive';
import { MetaDataService } from '../../../shared/services/meta-data.service';
import { ModuleHeaderComponent } from '../../../shared/components/module-header/module-header.component';
import { TabViewModule } from 'primeng/tabview';
import { forkJoin } from 'rxjs';
import { EntityCountsResponse, EntityList } from '../../../shared/models/entity.models';
import { ListResponse } from '../../../shared/models/listResponse.models';
import { AttributeData } from '../../../shared/models/attribute.models';

interface ColumnDefinition {
  attributeCode: string;
  attributeIndex: number;
  field: string;
  header: string;
  [key: string]: unknown;
}

interface FilterField {
  attributeId: number;
  attributeCode: string;
  attributeIndex: number;
  presetValues: Array<{
    labelKey: string;
    labelValue: string;
  }>;
  [key: string]: unknown;
}

@Component({
  selector: 'app-sites-list',
  standalone: true,
  imports: [BreadcrumbModule, ModuleHeaderComponent, TabViewModule, TranslateModule, MITableComponent, MITableComponent, AccessProviderDirective],
  templateUrl: './sites-list.component.html',
  styleUrl: './sites-list.component.scss'
})
export class SitesListComponent implements OnInit {
  @ViewChild('uploader', { static: true }) uploader: ElementRef<HTMLElement>;
  @ViewChild(MITableComponent) tableRef: MITableComponent;

  miIcons = AppIcons;
  activeIndex: number = 0;
  isLoading = true;
  filterAvailableColumns: string[] = [];
  cols: ColumnDefinition[] = [];
  moduleName = 'site';
  filterList: FilterField[] = [];
  btnLabel: string;
  items: MenuItem[] | undefined;
  isShowMenu: boolean = true;
  attributeLabels: Record<string, string> = {};
  filterAttributeLabels: Record<string, string> = {};
  listColumns: ColumnDefinition[] = [];
  allColumns: ColumnDefinition[] = [];
  pagination: { limit: number; offset: number; searchStr: string; defaultSortColumn?: string; defaultSortType?: string } = {
    limit: AppSettings.PAGINATION_ROWS_PER_PAGE_LIMIT,
    offset: 0,
    searchStr: ""
  };
  totalRecords: number = 0;
  tableData: Record<string, unknown>[] = [];
  buttons: Array<{ label: string; icon: string; command: () => void }> = [];
  country: Country;
  language: Language;
  entityCount: EntityCountsResponse;
  itemsPerPage: number;
  entityData: EntityList = {
    limit: AppSettings.PAGINATION_ROWS_PER_PAGE_LIMIT,
    offset: 0,
    searchStr: "",
    filters: [],
    countryCode: '',
    deleted: AppSettings.DELETED_TYPE.ONLY_NON_DELETED,
    forTenantCode: "",
    actionStatus: ''
  };
  routePath: MenuItem[] = [];
  deleteSiteMsg: string;
  deleteSiteHeaderMsg: string;
  showMenu: boolean = false;
  moduleHeaderSecondaryBtnMenuItems: MenuItem[] = [];
  filterFieldsArray: FilterField[] = [];
  isReady: boolean = false;
  attributeData: AttributeData;
  data: unknown;
  rowItems: MenuItem[] | undefined;
  bulkSelectionsItems: MenuItem[] | undefined;
  currentRow: Record<string, unknown>;
  visiblePrintLabel: boolean = false;
  showBulkUpdateDialog: boolean = false;
  visible: boolean = false;
  bulkUpdateHeader: string;
  reviewHeader: string;
  btnUpdate: { label: string; icon: string; command: () => void };
  entityCreatedAtAttributeId: string;
  regionGeofences: Array<{ id: string; name: string }> = [];
  zoneIds: string[] = [];
  isEntity = false;
  siteStatusAttributeId: string;
  showImportExportBtn: boolean = false;

  constructor(private siteService: EntityService,
    private cs: CommonBindingDataService, private confirmationService: ConfirmationService,
    private router: Router, private messageService: MessageService, private actRoute: ActivatedRoute,
    private metaDataService: MetaDataService,
    private restApiService: RestApiService,
    private configService: ConfigService, private permissionAccessService: PermissionAccessService,
    private cd: ChangeDetectorRef, private loaderService: LoaderService,
  ) { }

  ngOnInit() {
    this.initializeLabels();
    this.initializeRowItems();
    this.initializeModuleHeaderSecondaryBtnMenuItems();
    this.initializeOtherVariablesAndAPI();
    this.getMetaData();
  }

  getMetaData() {
    this.getEntityCount();
    const payload = this.getMultiApiPayload();
    this.metaDataService.metaDataMultipleApi(payload).subscribe((res) => {

      const advancedFilter = JSON.parse(res.advancedFilter.responseBody);
      if (advancedFilter) {
        this.setVehicleFilterView(advancedFilter);
      }


      const sort = JSON.parse(res.sort.responseBody);
      const entityCreatedAt = sort.tabs[0].groups[0].fields.find(field => field.attributeCode === AppSettings.ENTITY_CREATED_AT);
      this.entityCreatedAtAttributeId = entityCreatedAt.attributeId;
      if (this.entityCreatedAtAttributeId) {
        // this.entityData.defaultSortColumn = this.entityCreatedAtAttributeId;
        this.entityData.defaultSortType = AppSettings.DESC_SORT_ORDER;
      }


      const defaultTableView = JSON.parse(res.defaultTableView.responseBody);
      if (defaultTableView) {
        this.setSiteTableView(defaultTableView);
      }
      this.cs.applyFilterToColumn(defaultTableView, sort)

    });
  }

  private getMultiApiPayload() {
    return [
      {
        url: `${AppSettings.BASE_URL}${this.configService.getLoggedInTenantCode()}/api/v1/entity-conf/${AppSettings.ENTITY_CODE.SITE}/attributes?forTenantCode=${this.configService.getForTenantCode()}&viewCode=${AppSettings.VIEW_CODE.ADVANCED_FILTER_VIEW}`,
        inputBody: '',
        method: 'GET',
        outputKey: AppSettings.META_OUTPUT_KEY.ADVANCED_FILTER,
        headers: this.restApiService.getHeaderForMultipleAPI()
      },
      {
        url: `${AppSettings.BASE_URL}${this.configService.getLoggedInTenantCode()}/api/v1/entity-conf/${AppSettings.ENTITY_CODE.SITE}/attributes?forTenantCode=${this.configService.getForTenantCode()}&viewCode=${AppSettings.VIEW_CODE.DEFAULT_SORT_VIEW}`,
        inputBody: '',
        method: 'GET',
        outputKey: AppSettings.META_OUTPUT_KEY.SORT,
        headers: this.restApiService.getHeaderForMultipleAPI()
      },
      {
        url: `${AppSettings.BASE_URL}${this.configService.getLoggedInTenantCode()}/api/v1/entity-conf/${AppSettings.ENTITY_CODE.SITE}/attributes?forTenantCode=${this.configService.getForTenantCode()}&viewCode=${AppSettings.VIEW_CODE.DEFAULT_TABLE_VIEW}`,
        inputBody: '',
        method: 'GET',
        outputKey: AppSettings.META_OUTPUT_KEY.DEFAULT_TABLE_VIEW,
        headers: this.restApiService.getHeaderForMultipleAPI()
      },
    ]
  }

  private initializeRowItems() {
    const isEdit = this.permissionAccessService.hasAccess('SITES', '', 'ALL', 'EDIT');
    const isActivate = this.permissionAccessService.hasAccess('SITES', '', 'ALL', 'ACTIVATE');
    const isDelete = this.permissionAccessService.hasAccess('SITES', '', 'ALL', 'DELETE');
    this.rowItems = [
      ...(isEdit ? [{
        label: "Edit",
        icon: `${AppIcons.EDIT_2} wh-16`,
        iconClass: 'bulk-update-icon',
        command: () => {
          this.update();
        }
      }] : []),
      ...(isActivate ? [{
        label: this.cs.getLabel('site.lbl_activate'),
        icon: `${AppIcons.CIRCLE_CHECKED} wh-16`,
        iconClass: 'bulk-update-icon',
        value: 'active',
        command: () => {
          this.onUpdateStatus('Active', this.cs.getLabel('site.lbl_activate'));
        }
      }] : []),
      ...(isActivate ? [{
        label: this.cs.getLabel('site.lbl_deactivate'),
        icon: `${AppIcons.ACTIVATE} wh-16`,
        iconClass: 'bulk-update-icon',
        value: 'deactive',
        command: () => {
          this.onUpdateStatus('Inactive', this.cs.getLabel('site.lbl_deactivate'));
        }
      }] : []),
      { separator: true },
      ...(isDelete ? [{
        label: this.cs.getLabel('site.lbl_delete'),
        icon: `${AppIcons.BASIC_TRAY} wh-16`,
        iconClass: 'bulk-update-icon',
        command: () => {
          this.tableRef.delete(AppSettings.DELETE_TYPE.ROW);
        }
      }] : [])
    ];
  }

  onUpdateStatus(status, acceptLabelText) {
    const isActive = status === 'Active';
    this.confirmationService.confirm({
      header: this.cs.getLabel(isActive ? 'site.lbl_activate_confirmation' : 'site.lbl_deactivate_confirmation'),
      message: this.cs.getLabel(isActive ? 'site.msg_activate_confirmation' : 'site.msg_deactivate_confirmation'),
      acceptIcon: 'none',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'bg-white text-color cancel',
      acceptButtonStyleClass: 'bg-red-500 delete',
      acceptLabel: acceptLabelText,
      rejectLabel: this.cs.getLabel('lbl_cancel'),
      accept: () => {

        const siteData = {
          forTenantCode: this.configService.getForTenantCode(),
          entityCode: this.moduleName,
          countryCode: this.country[0].countryCode,
          languageCode: this.language?.[0]?.langCode || 'en',
          data: [{
            attributeId: this.siteStatusAttributeId,
            attributeValue: status
          }],
          relationshipData: [],
          viewCode: AppSettings.VIEW_CODE.STATUS_UPDATE_VIEW,
        };

        this.siteService.saveAttributeData(siteData.entityCode, this.currentRow.id as string, siteData).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: this.cs.getLabel('site.lbl_activate_successfully'),
            });
            setTimeout(() => {
              this.searchEntity();
              this.getEntityCount();
            }, 300);
          }
        });
      },
      reject: () => {
      }
    });
  }


  handleBulkUpdate() {
  }

  handleBulkPrint() {
  }

  private initializeModuleHeaderSecondaryBtnMenuItems() {

  }

  downloadImportTemplate() {
    this.siteService.downloadImportTemplate(AppSettings.ENTITY_CODE.SITE).subscribe(result => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(result);
      a.download = 'Import Template.xlsx';
      a.click();
    },
      () => {
      });
  }

  downloadImportGuide() {
    this.siteService.downloadImportGuide(AppSettings.ENTITY_CODE.SITE).subscribe(result => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(result);
      a.download = 'Import Guide.xlsx';
      a.click();
    },
      () => {
      });
  }

  private initializeLabels() {
    this.entityData.forTenantCode = this.configService.getForTenantCode();
    this.routePath = [{ label: "Sites", routerLink: 'app/sites' }];
  }

  private initializeOtherVariablesAndAPI() {
    this.btnLabel = this.cs.getLabel('Add Site');
    this.country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
    this.language = JSON.parse(localStorage.getItem(AppSettings.LANGUAGE));
    this.deleteSiteMsg = this.cs.getLabel('site.message.confirm_delete_msg');
    this.deleteSiteHeaderMsg = this.cs.getLabel('site.message.confirm_delete_header');
  }



  public onChange(event) {
    for (const file of event.target.files) {
      if (file) {
        if (file.size > AppSettings.FILE_UPLOAD_MAX_SIZE_IN_BYTE) {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: this.cs.getLabel('err_file_size_exceed_msg') });
        } else {
          const formData = new FormData();
          formData.append("file", file);
          formData.append('forTenantCode', this.configService.getForTenantCode());
          formData.append('entityCode', AppSettings.ENTITY_CODE.SITE);
          formData.append('viewCode', AppSettings.VIEW_CODE.EXCEL_IMPORT_VIEW);
          this.cs.importEntity(formData, AppSettings.ENTITY_CODE.SITE).subscribe(() => {
            this.messageService.add({ key: 'tst', severity: 'success', summary: 'Success', detail: this.cs.getLabel('lbl_file_uploaded_successfully') });
          })
        }
      }
    }
  }

  getAttributeData() {
    this.siteService.getAttributeDefinition(AppSettings.ENTITY_CODE.SITE, AppSettings.VIEW_CODE.BULK_UPDATE_VIEW).subscribe(res => {
      if (res) {
        this.setProductView(res);
      }
    });
  }

  setProductView(res) {
    this.attributeData = res;
    this.isLoading = false;
    this.filterFieldsArray = res.tabs[0].groups[0].fields;
    this.filterFieldsArray.forEach(element => {
      switch (element.attributeCode) {
        case 'vehicle_type':
          element.attributeValue = 'Type';
          element.isDisable = false;
          break;
        case 'vehicle_status':
          element.attributeValue = 'Status';
          element.isDisable = false;
          break;
      }
    });

  }

  setCurrentRowData(event) {
    this.currentRow = event;

    if (event.deleted) {
      this.rowItems.forEach(item => {
        if (!item.separator) {
          item.disabled = true;
        }
      });
      return;
    }

    this.rowItems.forEach(item => {
      switch (item.value) {
        case 'archive':
          item.disabled = event.actionStatus === 'ARCHIVE' || event.actionStatus === 'DELETED';
          break;
        case 'unarchive':
          item.disabled = event.actionStatus !== 'ARCHIVE' || event.actionStatus === 'DELETED';
          break;
        case 'active':
          item.disabled = event.site_status.Active === 'Active' || event.actionStatus === 'DELETED';
          break;
        case 'deactive':
          item.disabled = event.site_status.Inactive === 'Inactive' || event.actionStatus === 'DELETED';
          break;
        case 'edit':
          item.disabled = event.actionStatus !== 'UNARCHIVE' || event.actionStatus === 'DELETED';
          break;
        case 'delete':
          item.disabled = event.actionStatus === 'DELETED' || event.actionStatus === 'DELETED';
          break;
      }
    });
  }

  setEditOptionDisabledForDeletedRecord(data) {
    this.rowItems[0].disabled = data.deleted;
  }

  update() {
    this.onUpdateSite(this.currentRow.id);
  }

  getTableView() {
    this.siteService.getAttributeDefinition(AppSettings.ENTITY_CODE.SITE, AppSettings.VIEW_CODE.DEFAULT_TABLE_VIEW, false).subscribe(res => {
      if (res) {
        this.setSiteTableView(res);
      }
    });
  }

  setSiteTableView(res) {
    this.isLoading = false;
    this.data = res;
    this.attributeLabels = this.cs.getAttributeLabels(this.data) as unknown as Record<string, string>;
    this.siteStatusAttributeId = res.tabs[0].groups[0].fields.find(field => field.attributeCode === 'site_status')?.attributeId;
    this.allColumns = this.cs.getColumns(this.data).filter(column =>
      !['primary_default_address', 'site_address_short_name', 'site_address_line_2', 'site_street', 'site_city', 'site_state', 'site_zip'].includes(column.attributeCode)
    );
    this.searchEntity();
    this.allColumns?.forEach((key, index) => {
      this.allColumns[index] = key;
      this.allColumns[index].field = key.attributeCode;
      this.allColumns[index].header = this.cs.getLabelValue(
        `site.fields.${key.attributeCode}.label`,
        this.attributeLabels,
        key.attributeCode
      );
      if (key.attributeCode === 'site_address_line_1') {
        this.allColumns[index].header = this.cs.getLabel('site.lbl_site_address');
      }

    });
    this.filterAvailableColumns = _.clone(this.allColumns);
  }


  getFilterView() {
    this.siteService.getAttributeDefinition(AppSettings.ENTITY_CODE.SITE, AppSettings.VIEW_CODE.ADVANCED_FILTER_VIEW).subscribe(filterResponse => {
      if (filterResponse) {
        this.setVehicleFilterView(filterResponse);
      }
    });
  }

  setVehicleFilterView(filterResponse) {
    this.filterAttributeLabels = this.cs.getAttributeLabels(filterResponse) as unknown as Record<string, string>;
    this.filterList = this.cs.getColumns(filterResponse);
    this.filterList = _.sortBy(this.filterList, 'attributeIndex');
  }

  getData() {
    return forkJoin({
      tableViewData: this.getTableView(),
      filterViewDate: this.getFilterView(),
      getEntityCount: this.getEntityCount()
    })
  }

  onSortData(sortColumnDetails) {
    this.entityData.defaultSortColumn = sortColumnDetails.attributeId;
    this.entityData.defaultSortType = (sortColumnDetails.sortOrder === 1) ? AppSettings.ASC_SORT_ORDER : AppSettings.DESC_SORT_ORDER;
    this.searchEntity();
  }

  searchEntity() {
    try {
      this.loaderService.show();
      this.entityData.countryCode = AppSettings.HEADER_COUNTRY_CODE;

      this.siteService.searchEntity(AppSettings.ENTITY_CODE.SITE, this.entityData, false)
        .subscribe({
          next: (res: ListResponse) => {
            if (!res?.data?.length) {
              this.tableData = [];
              this.totalRecords = 0;
              return;
            }

            this.listColumns = (res.data[0]?.values as unknown as ColumnDefinition[]) || [];
            this.pagination = res.pagination;
            this.totalRecords = res.count || 0;
            this.tableData = [];

            this.tableData = res.data.map(data => ({
              id: data.id,
              ...(data.values || {})
            }));
          },
          error: () => {
            this.tableData = [];
            this.totalRecords = 0;
          },
          complete: () => {
            this.loaderService.hide();
          }
        });
    } catch (error) {
      this.loaderService.hide();
      this.tableData = [];
      this.totalRecords = 0;
    }
  }

  onAddSite() {
    this.router.navigate(['app/sites/add-site',]);
  }

  getLabel(params) {
    return `${params}hi`;
  }

  onRowClicked() {
    // Row click handler
  }

  onActionBtnClicked() {
    // Action button click handler
  }

  onPageChange(event) {
    this.entityData.offset = event?.first;
    this.entityData.limit = event?.rows;
    this.searchEntity();
  }

  itemPerPageChange(event) {
    this.itemsPerPage = event;
    this.entityData.limit = this.itemsPerPage;
    this.searchEntity();
  }

  onConfirmDelete() {
  }


  onSiteDelete(event) {
    const country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
    const requestBody = {
      forTenantCode: this.configService.getForTenantCode(),
      countryCode: country[0].countryCode,
      entityCode: AppSettings.ENTITY_CODE.SITE,
      entityIds: [
        event
      ]
    };
    this.siteService.deleteEntityActionStatus(requestBody).subscribe({
      next: () => {
        this.cs.onDisplayMessage(this.data, 'site', AppSettings.MSG_ACTION.DELETE, 'success');
        setTimeout(() => {
          this.searchEntity();
          this.getEntityCount();
        }, 300);
      },
      error: () => {
        this.cs.onDisplayMessage(this.data, 'site', AppSettings.MSG_ACTION.DELETE, 'error');
      }
    })
  }

  onUpdateSite(siteId) {
    this.router.navigate([`app/sites/add-site/${siteId}`]);
  }


  onRowSelect(event) {
    if (event.type === 'row') {
      this.router.navigate(['app/sites/site-details'], { queryParams: { tab: 'overview', id: event.data.id } });
      this.siteService.entityCurrentRow.next(event.data);
    }
  }


  onFilterValueChange(event) {
    const vData = event;
    this.entityData.filters = [];
    for (const [key, value] of Object.entries(vData)) {
      const attributeValue = value;
      if (attributeValue) {
        this.entityData.filters.push({
          attributeCode: key,
          attributeValue
        });
      }
    }
    this.entityData.filters = _.filter(_.uniq(this.entityData.filters, (item) => {
      if (item.attributeValue.length > 0) {
        return item.attributeCode;

      }
    }), (element) => {
      if (element.attributeValue.length > 0) {
        return true;
      }
      return false;
    });
    this.entityData.offset = event.first;
    this.entityData.filters = this.cs.mapAttributeIds(this.entityData.filters, this.filterList, 'filter');
    this.searchEntity();
  }


  onSearchValueChanges(event) {
    this.entityData.searchStr = event;
    this.searchEntity();
  }

  getEntityCount() {
    // const country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
    // const entityCountPayload = {
    //   forTenantCode: this.configService.getForTenantCode(),
    //   entityCode: AppSettings.ENTITY_CODE.SITE,
    //   countryCode: <string>country[0].countryCode,
    // };
    const res = {
      "tenantId": "2",
      "entityCode": "vehicle",
      "counts": {
        "UNASSIGNED": 48,
        "ALL": 84,
        "ASSIGNED": 27,
        "DELETED": 9
      }
    }

    // this.siteService.getEntityCount(AppSettings.ENTITY_CODE.SITE, entityCountPayload, false).subscribe((res: EntityCountsResponse) => {
    if (res?.counts) {
      res.counts.ALL = res.counts.ALL - res.counts.DELETED;
    }
    this.entityCount = res;
    // })
  }

  tabViewChange(event) {
    this.activeIndex = event.index;
    const actionStatus = '';
    switch (event.index) {
      case 0:
        this.entityData.actionStatus = actionStatus;
        this.entityData.deleted = AppSettings.DELETED_TYPE.ONLY_NON_DELETED;
        this.entityData.filters = [];
        this.tableRef.clearFilter();
        this.searchEntity();
        break;

      default:
        break;
    }
    if (event.index === 0) {
      this.showBulkUpdateDialog = false;
    }
  }

  onBulkDataUpdateEvent() {
    this.searchEntity();
  }

  onBulkDataDeleteEvent(event) {
    const requestBody = {
      forTenantCode: this.configService.getForTenantCode(),
      entityCode: AppSettings.ENTITY_CODE.SITE,
      countryCode: this.country[0].countryCode,
      entityIds: event
    };
    this.siteService.deleteEntityActionStatus(requestBody).subscribe({
      next: () => {
        this.cs.onDisplayMessage(this.data, 'vehicle', AppSettings.MSG_ACTION.BULK_DELETE, 'success');
        this.searchEntity();
        this.getEntityCount();
      },
      error: () => {
        this.cs.onDisplayMessage(this.data, 'vehicle', AppSettings.MSG_ACTION.BULK_DELETE, 'error');
      }
    });
  }

  isAttributeData(obj: unknown): obj is AttributeData {
    return obj && typeof obj === 'object' && 'tabs' in obj;
  }

  processData<T>(data: T): T {
    return data;
  }
}

